"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Channels Service
 * Channels Service REST API for Frumos.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.StreamingDeviceType = void 0;
/**
 * Device type to restrict.
 * @export
 * @enum {string}
 */
exports.StreamingDeviceType = {
    AndroidDevice: 'androidDevice',
    AndroidPhone: 'androidPhone',
    AndroidTablet: 'androidTablet',
    AndroidTv: 'androidTv',
    AndroidTvSony: 'androidTvSony',
    AppleTv: 'appleTv',
    FireTv: 'fireTv',
    IPad: 'iPad',
    IPhone: 'iPhone',
    IptvSmartTv: 'iptvSmartTv',
    IosDevice: 'iosDevice',
    ManagedAndroidTv: 'managedAndroidTv',
    ManagedCubiTv: 'managedCubiTv',
    MobileDevice: 'mobileDevice',
    Npvr: 'npvr',
    RokuTv: 'rokuTv',
    Stb: 'stb',
    WebPlayer: 'webPlayer',
    WebPlayerChrome: 'webPlayerChrome',
    WebPlayerMicrosoft: 'webPlayerMicrosoft',
    WebPlayerSafari: 'webPlayerSafari'
};
